import {
  loadCompetitionApiCall,
  submitApiCall,
  optinApiCall, renderShareApiCall, dynamicRenderApiCall, webhookRegisterApi,
  getGlobalScriptsForCustomerApi,
  updateVBPInnerApi
} from "../util/api_calls/ProjectApiCalls";
import history from "../history";
import { decodeOtherLanguage } from "../util/helpers/Helpers";
import {  showEmbedFooter } from '../util/helpers/Helpers';

const loadCompetition = (hash, dispatch) => {
  loadCompetitionApiCall(
    { hash },
    payload => {
      if (
        payload.data.hasOwnProperty("legacyCharEncoding") &&
        !payload.data.legacyCharEncoding
      ) {
        payload.data.detail = decodeOtherLanguage(payload.data.detail);
        payload.data.description = decodeOtherLanguage(
          payload.data.description
        );
        payload.data.lastPageCopy = decodeOtherLanguage(
          payload.data.lastPageCopy
        );
        payload.data.thanksCopy = decodeOtherLanguage(payload.data.thanksCopy);
        payload.data.drawCopy = decodeOtherLanguage(payload.data.drawCopy);
      }

      dispatch(loadCompetitionFinish(payload));
    },
    error => {
      dispatch(loadCompetitionError(error));
    }
  );

  return {
    type: "LOAD_COMP_START",
    payload: {}
  };
};

const loadCompetitionFinish = payload => {
  return {
    type: "LOAD_COMP_FINISH",
    payload: {
      ...payload
    }
  };
};

const loadCompetitionError = error => {

  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "LOAD_COMP_ERROR",
    payload: payload
  };
};

const submitVote = (body, hash, dispatch) => {
  submitApiCall(
    body,
    payload => {
      dispatch(submitFinish(hash, payload));
    },
    error => {
      dispatch(submitError(error));
    }
  );

  return {
    type: "SUBMIT_START",
    payload: {}
  };
};

const submitFinish = (hash, payload) => {
  const hasEmbedFooter = showEmbedFooter();
  if (hash.includes("/")) {
    if(hasEmbedFooter){
      history.push(`${hash}/thanks?embed=true`);
    }else{
      history.push(`${hash}/thanks`);
    }
  } else if (hash.includes("__CURL_")) {
    if (hasEmbedFooter) {
      history.push(`thanks?embed=true`);
    } else {
      history.push(`thanks`);
    }
  } else {
    // [hash removal] remove this after hash migration
    if(hasEmbedFooter){
      history.push(`/thanks?embed=true#${hash}`);
    }else{
      history.push(`/thanks#${hash}`);
    }
  }


  return {
    type: "SUBMIT_FINISH",
    payload: {
      ...payload.data
    }
  };
};

const submitError = error => {
  console.error("error", error);
  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "SUBMIT_ERROR",
    payload: payload
  };
};

const submitOptin = (body, dispatch, hash) => {
  optinApiCall(
    body,
    payload => {
      dispatch(optinFinish(payload, body, hash));
    },
    error => {
      dispatch(optinError(error));
    }
  );

  return {
    type: "OPTIN_START",
    payload: {}
  };
};

const optinFinish = (payload, comp, hash) => {

  localStorage.setItem('optinFinished', true);
  localStorage.removeItem('omnihubPrefilData');

  if (payload && payload.data && payload.data.idOptin) {
    localStorage.setItem(`idOptin-${comp.idCompetition}`, payload.data.idOptin);
  }

  console.log('pay-optin', payload);
  console.log('pay-optin-1', comp);

  if (hash.includes("/")) {
    history.push(`${hash}/thanks`);
  } else if (hash.includes("__CURL_")) {
    history.push(`thanks`);
  } else {
    // [hash removal] remove this after hash migration
    history.push("/thanks");
  }

  return {
    type: "OPTIN_FINISH",
    payload: {
      ...payload.data
    }
  };
};

const optinError = error => {
  console.error("error", error);
  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "OPTIN_ERROR",
    payload: payload
  };
};

const renderShareProcess = (enabledSocialNetworks, idSocialNetwork) => {
  if (enabledSocialNetworks) {
    var shareUrl = '';
    var shareText = '';
    enabledSocialNetworks.forEach(function (sn) {
      if (sn.id && sn.id === idSocialNetwork) {
        shareUrl = sn.url;
        shareText = sn.copy;
      }
    });

    if (shareUrl != '') {
      switch (idSocialNetwork) {
        case 1:
          window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl),
            'facebook-share-dialog', 'width=626,height=436'
          );
          break;
        case 2:
          window.open('http://www.twitter.com/intent/tweet?url=' +
            encodeURIComponent(shareUrl) + '&text=' + encodeURIComponent(shareText),
            'twitter-share-dialog', 'width=626,height=436'
          );
          break;
      }
    }
  }
};

const renderShare = (body, dispatch, idSocialNetwork) => {
  renderShareApiCall(
    body,
    payload => {
      dispatch(renderShareFinish(payload, idSocialNetwork));
    },
    error => {
      dispatch(submitError(error));
    }
  );

  return {
    type: "RENDER_SHARE_START",
    payload: {}
  };
};

const renderShareFinish = (payload, idSocialNetwork) => {

  if (payload.data && payload.data.enabledSocialNetworks) {
    renderShareProcess(payload.data.enabledSocialNetworks, idSocialNetwork);
  }

  return {
    type: "RENDER_SHARE_FINISH",
    payload: {
      ...payload.data
    }
  };
};

const dynamicRender = (body, dispatch) => {
  dynamicRenderApiCall(
    body,
    payload => {
      dispatch(dynamicRenderFinish(payload));
    },
    error => {
      dispatch(submitError(error));
    }
  );

  return {
    type: "DYNAMIC_RENDER_START",
    payload: {}
  };
};

const dynamicRenderFinish = (payload) => {

  if (payload.data && payload.data.dynamicRenderUrl) {
    localStorage.setItem('dynamicRenderUrl', payload.data.dynamicRenderUrl);
  }

  return {
    type: "DYNAMIC_RENDER_FINISH",
    payload: {
      ...payload.data
    }
  };
};

const webhookRegister = (parameters, dispatch) => {

    webhookRegisterApi(
        parameters,
        payload => {
            dispatch(webhookRegisterFinish(payload))
        },
        error => {
            dispatch(submitError(error))
        }
    );

    return {
        type: 'POST_SIGNUP_START',
        payload: parameters
    }
}

const webhookRegisterFinish = payload => {
    return {
        type: 'WEBHOOK_REGISTER_FINISH',
        payload: {
            ...payload,
        }
    }
}

const getGlobalScriptsForCustomer = (hash, dispatch) => {

    getGlobalScriptsForCustomerApi(
        hash,
        payload => {
            dispatch(getGlobalScriptsForCustomerFinish(payload.hash, payload, dispatch))
        },
        error => {
            dispatch(submitError(error))
        }
    );

    return {
        type: 'GET_GLOBAL_SCRIPTS_START',
        payload: {}
    }
}

const getGlobalScriptsForCustomerFinish = (hash, payload, dispatch) => {

    console.log("Looking for global scripts for customer...");

    return {
        type: 'GET_GLOBAL_SCRIPTS_FINISH',
        payload: {
            ...payload
        }
    }
}

const updateVBPInner = (idCompetition, data, dispatch) => {

    updateVBPInnerApi(
        idCompetition,
        data,
        payload => {
            dispatch(updateVBPInnerFinish(payload))
        },
        error => {
            dispatch(submitError(error))
        }
    );

    return {
        type: 'UPDATE_VB_START',
        payload: {}
    }
}

const updateVBPInnerFinish = payload => {

    return {
        type: 'UPDATE_VB_FINISH',
        payload
    }
}

export { loadCompetition, submitVote, submitOptin,
  renderShare, renderShareProcess, dynamicRender, updateVBPInner,
  webhookRegister, webhookRegisterFinish, getGlobalScriptsForCustomer };
